@if (dashboard) {
    <div class="name-wrapper">
        <h1 [title]="dashboard.name">{{ dashboard.name }}</h1>
        @if (!shouldHideEditIcon) {
            <cc-icon
                title="Edit Workspace"
                [icon]="'edit-pencil'"
                [size]="'small'"
                (iconClicked)="switchToEditMode.emit()"
            >
            </cc-icon>
        }
    </div>

    @if (group) {
        <ddv-peer-carousel
            [group]="group"
            [selectedDashboardId]="dashboard.id?.toString() ?? '0'"
            (selectedDashboardIdChange)="dashboardSwitch.emit($event)"
        >
        </ddv-peer-carousel>
    }
}
